import React, {useState, useEffect} from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { useStyles } from './styles';

import generalTermsMd from '../../../assets/terms/general-terms-v1.md';
import saasAgreementMd from '../../../assets/terms/saas-agreement-v1.md';

const TermsMarkdownContent = () => {
  const classes = useStyles();
  const [generalTerms, setGeneralTerms] = useState('');
  const [saasAgreement, setSaasAgreement] = useState('');

  useEffect(() => {
    let cancelled = false;

    Promise.all([
      fetch(generalTermsMd).then(res => res.text()),
      fetch(saasAgreementMd).then(res => res.text()),
    ]).then(([general, saas]) => {
        if (cancelled) return;
        setGeneralTerms(general);
        setSaasAgreement(saas);
      })
    return () => { cancelled = true; };
  }, []);

  return (
    <div className={classes.markdownContent}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{generalTerms}</ReactMarkdown>
      <hr className={classes.divider} />
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{saasAgreement}</ReactMarkdown>
    </div>
  );
};

export default TermsMarkdownContent;
